import { Controller } from "@hotwired/stimulus"
// Onboarding "Configuration" step: plays the staged AI setup — each task
// spins for a moment then completes — and unlocks the submit button at the
// end. Purely presentational; the real work happens after review.
export default class extends Controller {
  static targets = ["task", "submit"]

  connect() { this.run() }
  disconnect() { this.cancelled = true }

  async run() {
    for (const task of this.taskTargets) {
      if (this.cancelled) return
      task.dataset.state = "running"
      await this.wait(9000 + Math.random() * 2000) // ~10s per task, ~40s total
      task.dataset.state = "done"
    }
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
  }

  wait(ms) { return new Promise((resolve) => setTimeout(resolve, ms)) }
}
